<template>
    <div class="body">
        <van-tabs @click="onClick">
            <van-tab v-for="index in vanTab" :title="index" :key="index"/>
        </van-tabs>
         <mt-loadmore :bottom-method="getAgentPrechargeListHandler" :bottom-all-loaded="allLoaded"  :auto-fill="false" ref="loadmore">
            <van-row class="el-col-row">
                <van-col span="12" v-for="item in dataList" :key="item.id"  @click.native="linkOpen(item)">
                    <div class="item-data">
                        <img :src="item.img" alt=""/>
                        <div class="goodsTitle">{{item.shareName}}</div>
                        <div class="goodsPrc">¥{{item.sharePrice}}</div>
                    </div>
                </van-col>
            </van-row>
         </mt-loadmore>
        <div class="slecjg" @click="selectChange()">查询订单</div>
    </div>    
</template>
<script>
import {wxRequest} from '@/api/user.js' 
export default {
    data(){ 
        return {
            dataList:[],
            pageNo: 0,
            perPageNum: 10,
            allPage: 0,
            agentId:'',
            vanTab:[],
            allLoaded: false ,
            title:''         
        }
    },
    created(){
        this.agentId= this.$route.query.agentId || ''
        wxRequest("applyChangeSim/share/type/group", {}, "post").then(res => {
            if(res.data.code === '200'){
                this.vanTab = res.data.data   
                this.title = res.data.data.length > 0 ?  res.data.data[0] : ''
                this.getAgentPrechargeListHandler()
            }
        })
    },
    methods:{
        onClick(name, title){
            this.title = title
            this.pageNo = 0
            this.dataList =[]
            this.getAgentPrechargeListHandler()
        },
        selectChange(){
         	this.$router.push({ path: '/user/buyOrderSearch', query: { realNameCard: 1 } });
        },
        getAgentPrechargeListHandler(){
            this.pageNo += 1;
            var params = {
                pageNo: this.pageNo,
                shareType:this.title,
                agentId:this.agentId,
                perPageNum: this.perPageNum,
            }
            wxRequest("applyChangeSim/share/group", params, "post").then(res => {
                if(res.data.code == 200){
                   this.allPage = Math.ceil(res.data.data.totalNum / this.perPageNum)
                    if(this.pageNo == this.allPage){
                        this.allLoaded = true;
                    }
                    var data = res.data.data.resultList.map(item=>{
                        item.img = process.env.VUE_APP_IMG_URL + '/' + item.shareImg
                        return item
                    })
                    this.dataList = this.dataList.concat(data)
                    this.$refs.loadmore.onBottomLoaded();    
                    this.$nextTick(function(){
                        window.scroll(0,0);
                    })                   
                }
            })
        },
        linkOpen(data){
            window.open(data.url)
        }
    }
}
</script>
<style lang="less" scoped>
    .body{
        height:100%;
        width: 100%;
        .header{
            padding-bottom:10px;
            img{
                width:100%;
            }
        }
        .item-data{
            padding:10px;
            img{
                width:100%;
                // height:130px;
            }
            .goodsTitle{
                font-size: 14px;
                font-weight:bold;
                color:#525253;
                line-height: 1.2rem;
            }
            .goodsPrc{
                color:#CB353B;
                font-size: 18px;
                margin-top:10px;
            }
        }
    }
    .slecjg{
        width: 138px;
        height: 44px;
        background: #CB353B;
        font-size: 16px;
        color: #fff;
        border-radius: 22px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        bottom: 20px;
        right: 0;
        left:0;
        margin:0 auto;
    }
</style>